import { render, staticRenderFns } from "./BuyPackage.vue?vue&type=template&id=c6f511ae&"
import script from "./BuyPackage.vue?vue&type=script&lang=js&"
export * from "./BuyPackage.vue?vue&type=script&lang=js&"
import style0 from "./BuyPackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports